import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

function isAdminRole(role) {
  const normalized = String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return normalized === "admin" || normalized === "super_admin";
}

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
        <p className="text-gray-700 dark:text-gray-300">Loading...</p>
      </div>
    );
  }

  if (!user || !isAdminRole(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
